"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Transforms the data in a Redux Form component to the format required by the API.
 * The data should be in the form given by this.props.values in the connected Redux Form
 *   component.
 * @param {Object} formValues - The form values to transform.
 * @returns {Array} - Array of transformed applicants.
 */

exports.default = function (formValues, trackingCode) {
  return [_extends({
    country_code: formValues.application.additional_data.country_of_origin,
    primary_applicant: true
  }, formValues.applicant[0], {
    additional_data: _extends({}, formValues.applicant[0].additional_data),
    state: formValues.application.additional_data.province_of_residence
  })].concat(_toConsumableArray(formValues.applicant.slice(1).map(function (applicant) {
    return _extends({}, applicant, {
      primary_applicant: false
    });
  })));
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/all-inclusive/applicant.js
// module id = 1736
// module chunks = 0